import { Injectable } from '@angular/core';
import {
  ClaimFacade,
  ChatClientService,
  UserService,
} from '@domgen/data-access-claims';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ClaimsAppComponentService {
  loadingState$: Observable<{
    isLoading: boolean;
    message: string | null;
  }> = this.claimFacade.loadingState$;

  user$ = this.claimFacade.user$;

  constructor(
    private readonly user: UserService,
    private readonly chatClient: ChatClientService,
    private readonly claimFacade: ClaimFacade
  ) {
    this.chatClient.routeListener().subscribe();
  }

  logout(routeToLogin: boolean, homepageURL: string = '') {
    this.user.logout(routeToLogin, homepageURL).subscribe();
  }
}
